// components/Footer.js
import {
  FaInstagram,
  FaFacebook,
  FaTwitter,
  FaTiktok,
  FaLinkedinIn,
} from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="bg-black py-6 w-full">
    <div className="container mx-auto flex flex-col md:flex-row items-center relative">
      {/* Título centralizado */}
      <div
        className="text-marfim text-xl uppercase leading-10 tracking-widest mb-6 md:mb-0 absolute inset-x-0 text-center"
        style={{ letterSpacing: "10px" }}
      >
        {process.env.TITLE}<br></br>
            <p className="text-xs leading-tight tracking-tighter">
              
              - Copyright ® 2025 - Todos os Direitos Reservados.
            </p>
            <p className="text-xs leading-tight tracking-tighter">
              
              Contato:{process.env.NEXT_PUBLIC_PHONE_NUMBER}
            </p>
      </div>
  
      {/* Redes sociais no canto */}
      <div className="flex flex-wrap items-center justify-end w-full md:w-auto md:ml-auto">
        {process.env.INSTAGRAM && (
          <a
            href={process.env.INSTAGRAM}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center space-x-2 px-2 mt-2"
          >
            <div className="p-2 rounded">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512"
                width="20"
                height="20"
              >
                <linearGradient id="instagramGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" style={{ stopColor: "#f09433" }} />
                  <stop offset="25%" style={{ stopColor: "#e6683c" }} />
                  <stop offset="50%" style={{ stopColor: "#dc2743" }} />
                  <stop offset="75%" style={{ stopColor: "#cc2366" }} />
                  <stop offset="100%" style={{ stopColor: "#bc1888" }} />
                </linearGradient>
                  <path
                    fill="url(#instagramGradient)"
                    d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9S160.5 370.8 224.1 370.8 339 319.5 339 255.9 287.7 141 224.1 141zm0 186.6c-39.5 0-71.7-32.2-71.7-71.7s32.2-71.7 71.7-71.7 71.7 32.2 71.7 71.7-32.2 71.7-71.7 71.7zm146.4-194.3c0 14.9-12.1 27-27 27s-27-12.1-27-27 12.1-27 27-27 27 12.1 27 27zm76.1 27.2c-.7-37.4-10.3-70.7-38-98.4s-61-37.3-98.4-38c-38.8-2.2-154.6-2.2-193.4 0-37.4.7-70.7 10.3-98.4 38C10.3 98.3.7 131.6 0 169c-2.2 38.8-2.2 154.6 0 193.4.7 37.4 10.3 70.7 38 98.4s61 37.3 98.4 38c38.8 2.2 154.6 2.2 193.4 0 37.4-.7 70.7-10.3 98.4-38s37.3-61 38-98.4c2.2-38.8 2.2-154.6 0-193.4zm-48.5 240c-7.8 19.6-22.9 34.7-42.5 42.5-29.4 11.7-99.2 9-132 9s-102.6 2.6-132-9c-19.6-7.8-34.7-22.9-42.5-42.5-11.7-29.4-9-99.2-9-132s-2.6-102.6 9-132c7.8-19.6 22.9-34.7 42.5-42.5 29.4-11.7 99.2-9 132-9s102.6-2.6 132 9c19.6 7.8 34.7 22.9 42.5 42.5 11.7 29.4 9 99.2 9 132s2.7 102.6-9 132z"
                  />
                </svg>
              </div>
              
            </a>
          )}
          {process.env.FACEBOOK && (
            <a
              href={process.env.FACEBOOK}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center space-x-2 px-2 mt-2"
            >
              <div className="p-2 bg-black text-primary rounded">
                <FaFacebook size={20} />
              </div>
              <span className="text-black">Facebook</span>
            </a>
          )}
          {process.env.TWITTER && (
            <a
              href={process.env.TWITTER}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center space-x-2 px-2 mt-2"
            >
              <div className="p-2 bg-black text-primary rounded">
                <FaTwitter size={20} />
              </div>
              <span className="text-black">Twitter</span>
            </a>
          )}
          {process.env.LINKEDIN && (
            <a
              href={process.env.LINKEDIN}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center space-x-2 px-2 mt-2"
            >
              <div className="p-2 bg-black text-primary rounded">
                <FaLinkedinIn size={20} />
              </div>
              <span className="text-black">Linkedin</span>
            </a>
          )}
          {process.env.TIKTOK && (
            <a
              href={process.env.TIKTOK}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center space-x-2 px-2 mt-2"
            >
              <div className="p-2 bg-black text-primary rounded">
                <FaTiktok size={20} />
              </div>
              <span className="text-black">Tiktok</span>
            </a>
          )}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
